// i18n.js
import { createI18n } from 'vue-i18n';
import message_ch from "@/language/message";
import Message_TW from "@/language/message_TW";
import message_en_US from "@/language/message_en_US";

const messages = {
    ch: {
        message: message_ch
    },
    ch_TW: {
        message:  Message_TW
    },
    "en-US": {
        message: message_en_US
    }
};
const i18n = createI18n({
    locale: navigator.language, // set default locale
    fallbackLocale: 'ch', // set fallback locale
    messages, // set locale messages
    globalInjection: true, // 全局注册
    silentTranslationWarn: true,
    missingWarn: false,
    silentFallbackWarn: true,
});

export default i18n;